module.exports = __webpack_public_path__ + "img/u82.9a76a333.svg";